import { ChangeEventArgs, DropDownListComponent } from '@syncfusion/ej2-react-dropdowns'
import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks.tsx'
import dayjs from 'dayjs'
import { FC, useEffect, useRef, useState } from 'react'

import styles from './VersionSelectDd.module.scss'
import { NwLecturerApplicationDto } from '../../../types/NwLecturerApplicationDto.tsx'
import { setSelectedRegIdxFromDd } from '../../../redux/registerSlice.tsx'


type VersionSelectDdProps = {
  responsive?: boolean
}


export const VersionSelectDd: FC<VersionSelectDdProps> = ({ responsive }) => {
  const registerVersions = useAppSelector((state) => state.register.registrations)
  const selectedIdx = useAppSelector(state => state.register.selectedIdx)
  const [no, setNo] = useState<number | undefined>()

  const [sortedRegisterVersions, setSortedRegisterVersions] = useState<NwLecturerApplicationDto[]>([])
  const dispatch = useAppDispatch()

  const dDVerions = useRef<DropDownListComponent>(null)

  useEffect(() => {
    if (selectedIdx)
      setNo(selectedIdx)
  }, [selectedIdx])

  useEffect(() => {
    console.log(selectedIdx)
    if (registerVersions) {
      setSortedRegisterVersions(registerVersions.slice().sort((b, a) => a.actualIndex - b.actualIndex))
    }
  }, [registerVersions])

  const onChangeHandler = (event: ChangeEventArgs) => {
    if (event.isInteracted) {
      dispatch(setSelectedRegIdxFromDd(event.value))
    } else {
      if (import.meta.env.DEV)
        console.log(event)
    }
  }

  // Erstellen Sie das benutzerdefinierte Template
  const itemTemplate = (data: NwLecturerApplicationDto) => {
    return (
      <>{`v${data.actualIndex}: ${dayjs(data.lastChangeDate).format('DD.MM.YYYY HH:mm')} Uhr`}</>
    )
  }

  const fields = { text: 'lastChangeDate', value: 'actualIndex' }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <p className={styles.versionLabel}>Version:</p>
        <div className={responsive ? styles.mobileHidden : ''}>
          <DropDownListComponent
            ref={dDVerions}
            dataSource={sortedRegisterVersions}
            itemTemplate={itemTemplate}
            valueTemplate={itemTemplate}
            fields={fields}
            width="220px"
            popupWidth="220px"
            popupHeight="200px"
            placeholder="Version auswählen..."
            change={onChangeHandler}
            value={no}
          />
        </div>
        {/*{responsive ? (*/}
        {/*  <div className={responsive ? styles.mobileVisible : ''}>*/}
        {/*    <DropDownListComponent dataSource={modifiedMobileDatasource} fields={{ text: 'text', value: 'value' }} width="55px" popupWidth="55px" popupHeight="160px" placeholder="v..." onChange={handleChangeVersion} value={initialValue} />*/}
        {/*  </div>*/}
        {/*) : null}*/}
      </div>


    </>
  )
}
